import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { CHECKOUT_URL } from '../data/content';
import { trackPixel } from '../utils/metaPixel';
type CTAButtonProps = {
  label: string;
  note?: string;
  size?: 'md' | 'lg';
  pulse?: boolean;
  className?: string;
  noteClassName?: string;
};
export function CTAButton({
  label,
  note,
  size = 'md',
  pulse = false,
  className = '',
  noteClassName = 'text-navy-700/70'
}: CTAButtonProps) {
  const sizing = size === 'lg' ? 'px-6 py-5 text-base sm:text-lg' : 'px-5 py-4 text-[15px] sm:text-base';
  return <div className={`w-full ${className}`} data-id="element-97" data-mp="33p63yrn6uslg">
      <a href={CHECKOUT_URL} onClick={() => trackPixel('InitiateCheckout')} className={`group flex w-full items-center justify-center gap-2 rounded-xl bg-brand text-center font-sans font-extrabold uppercase tracking-wide text-white shadow-lift transition-transform duration-200 hover:bg-brand-dark focus:outline-none focus-visible:ring-4 focus-visible:ring-brand/40 active:scale-[0.98] ${sizing} ${pulse ? 'cta-pulse' : ''}`} data-id="element-98" data-mp="33o4jjwka8tr2">
        <span className="leading-snug" data-id="element-99" data-mp="1d9ym7wv2s69q">{label}</span>
        <ArrowRightIcon className="h-5 w-5 shrink-0 transition-transform duration-200 group-hover:translate-x-1" aria-hidden="true" data-id="element-100" data-mp="1dckqnnmo65nq" />
      </a>
      {note && <p className={`mt-3 text-center text-[12.5px] font-medium leading-relaxed ${noteClassName}`} data-id="element-101" data-mp="1n9z89qkbx0hm">
          {note}
        </p>}
    </div>;
}